import React from "react";
import "./ServiceCard.css";

const ServiceCard = ({
  icon,
  title,
  description,
  iconWidth = 48,
  iconHeight = 48,
}) => {
  return (
    <div className="service-card">
      <div
        className="service-icon"
        style={{
          width: iconWidth,
          height: iconHeight,
        }}
      >
        {icon}
      </div>

      <h3 className="service-title">{title}</h3>
      <p className="service-description">{description}</p>
    </div>
  );
};

export default ServiceCard;
